/**
 * Frontend mirror of the backend's `Submission#clarifications_requestable?`
 * (app/models/concerns/submissions/sub_status.rb).
 *
 * Clarifications are active for any submission status except:
 *   draft    – not yet submitted, nothing to clarify yet
 *   complete – fully done
 *
 * This is independent of sub_status/ClarificationRound state, which governs
 * visibility and editability separately.
 */
export function isClarificationsActiveStatus(
  status: string | null | undefined
): boolean {
  if (!status) return false;
  if (status === 'draft') return false;
  if (status === 'complete') return false;
  return true;
}
